import { Box, Typography } from '@mui/material';
import type { Usage } from '../types';

interface TokenUsageInfoProps {
  usage: Usage | null | undefined;
}

export default function TokenUsageInfo({ usage }: TokenUsageInfoProps) {
  if (!usage || (!usage.tokens_in && !usage.tokens_out)) return null;

  return (
    <Box
      sx={{
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae6fd',
        borderRadius: 2,
        p: 2,
        mb: 2,
        color: '#075985',
      }}
    >
      <Typography variant="body1" fontWeight={600}>
        Статистика приёма:
      </Typography>
      <Typography variant="body2">
        Модель: {usage.model || '—'}, Токены: {usage.tokens_in || 0} вход / {usage.tokens_out || 0} выход,
        Стоимость: {(usage.cost ?? 0).toFixed(6)} USD
      </Typography>
    </Box>
  );
}
